module.exports = __webpack_public_path__ + "static/Storefront In-Store Place Based Billboards Specs 2026-8b944b752e6159a2008a273340d4889d.pdf";